export default __webpack_public_path__ + "static/media/time.7603604b.svg";